module.exports = __webpack_public_path__ + "img/4-6claim.853a1b48.png";